
























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { BackStoryData } from '../../../module/backStory';
import Item from './item.vue';

@Component({
  components: { Item },
})
export default class Presentational extends Vue {
  @Emit() public close() {}

  private get ideologies() {
    return BackStoryData.ideology();
  }
  private get keyPerson() {
    return BackStoryData.keyPerson();
  }
  private get reason() {
    return BackStoryData.reason();
  }
  private get keyPoint() {
    return BackStoryData.keyPoint();
  }
  private get precious() {
    return BackStoryData.precious();
  }
  private get characteristic() {
    return BackStoryData.characteristic();
  }
}
